import {Injectable} from "@angular/core";
import {BrukerkontekstTilbyder} from "../../tjenester/BrukerkontekstTilbyder";
import {getRegistry, Store} from "@ngneat/elf";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {EntitetLager} from "felles-ng2/tjenester/datalager/datatjeneste";

const debug = initDebugger('ResetDatalagerVedUtlogging');

/**
 * Sørger for å resette alle {@link Store} når bruker blir logget ut.
 */
@Injectable({providedIn: 'root'})
export class ResetDatalagerVedUtlogging {

    constructor(private kontekstTilbyder: BrukerkontekstTilbyder) {
    }

    resetVedUtlogging() {
        this.kontekstTilbyder.brukerLoggetUtSomStrøm().subscribe(() =>
          this.resetAlle());
    }

    // private hjelpemetoder

    private resetAlle() {
        getRegistry().forEach((store: EntitetLager<any>) => {
            debug(`resetter datalager:${store.name}, antall innslag før reset: ${store.state.ids.length}`, store)
            store.reset()
        });
    }
}
